var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-flex flex-column" }, [
    _c("div", { staticClass: "sidebar-top" }, [
      _c("div", { staticClass: "sidebar-item" }, [_c("export-btn")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("job-queued")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-item feedback-item feedback-item-bg d-none" },
        [_c("feedback")],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-right-bot" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }